<template>
  <div class="attr-material">
    <!--<h3 class="c-ellipsis">{{value.originName}}</h3>-->
    <section v-if="!tplData.free">
      <h4>多素材操作设置</h4>
      <ul>
        <li>
          <el-checkbox v-model="value.disabled" key="2" @change="onValueChange('disabled')">禁止操作</el-checkbox>
        </li>
        <li>
          <el-checkbox v-model="value.fixed" key="3" @change="onValueChange('fixed')">禁止联动</el-checkbox>
        </li>
        <li>
          <el-checkbox v-model="value.allowHide" key="1" @change="onValueChange('allowHide')">支持隐藏</el-checkbox>
        </li>
      </ul>
    </section>
    <section v-if="!isSingleTemplate">
      <h4>素材属性设置</h4>
      <div>
        <el-radio-group v-model="bgVal" @change="onBgValChange">
          <el-radio-button label="0">无</el-radio-button>
          <el-radio-button label="2">背景素材</el-radio-button>
        </el-radio-group>
      </div>
    </section>
    <section>
      <h4>素材透明度%</h4>
      <div class="slider-input-body">
        <el-slider v-model="opacity" @change="onOpacityChange" :format-tooltip="formatterOpacityTip"></el-slider>
        <span class="ipt">
          <el-input-number class="" controls-position="right" :max="100" :min="0" style="width: 100px" size="small"
                           v-model="opacity"></el-input-number></span>
      </div>
    </section>
    <section>
      <h4>圆角</h4>
      <div>
        <label>自定义圆角</label>
        <div class="slider-input-body">
          <el-slider v-model="value.borderRadius" @change="onRadiusChange"></el-slider>
          <span class="ipt">
             <el-input-number v-model="value.borderRadius" :max="100" class="radius-input" @change="onRadiusChange" size="small"
                              controls-position="right"></el-input-number>
          </span>
        </div>
        <p>
          <el-checkbox v-model="value.isCircle" class="set-circle" @change="onCheckChange">设置为圆形</el-checkbox>
        </p>
      </div>
    </section>
    <section v-if="!tplData.free">
      <h4>拼图</h4>
      <div>
        <p>
          <el-checkbox v-model="value.isGroupMaterial" @change="onValueChange('isGroupMaterial')">支持拼图</el-checkbox>
        </p>
        <div class="pintu-list" v-if="value.isGroupMaterial">
          <ul>
            <template v-for="(item , index) in pintuList">
              <li :key="index">
                <div class="gl-img-box bg-hover">
                  <img :src="item.coverUrl"/>
                  <span class="del-bg">
                  <i class="el-icon-delete del-icon" @click="onDelGroupItem(item, index)"></i>
                </span>
                </div>
                <p class="gl-img-name">{{item.name}}</p>
              </li>
            </template>
          </ul>
          <div class="upload-btn">
            <pintu-uploader @onCompleted="onUploadCompleted" :template-id="tplData.id"
                            :project-id="tplData.projectId" :auto-save="false">
              <template slot-scope="slotData">
                <el-button round type="default" plain icon="el-icon-plus" :disabled="slotData.loading">
                  {{slotData.loading ?
                  '上传中...': '上传拼图素材'}}
                </el-button>
              </template>
            </pintu-uploader>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
    import {group_type_pt, template_type_single} from '@/const.js';
    import groupService from '../../../request/service/group-service'
    import pintuUploader from '../../template/img-template/uploader'
    import util from '@/util.js';

    const empty_data = {
        allowHide: null,
        disabled: null,
        fixed: null,
        direction: '',
        borderRadius: null,
        borderRadiusValue: null,
        isGroupMaterial: null,
        opacity: 1
    };
    export default {
        components: {pintuUploader},
        props: {
            dataList: Array,
            tplData: Object
        },
        data() {
            return {
                bgVal: 0,
                opacity: 0,
                pintuList: [],
                value: Object.assign({}, empty_data),
            };
        },
        computed: {
            isSingleTemplate() {
                return this.tplData.type === template_type_single;
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                Object.assign(this.value, empty_data);
                let tplId = this.tplData.id;
                if (!tplId) {
                    return;
                }
                this.opacity = parseInt(+this.value.opacity * 100);
                this.getData();
            },
            getData() {
                this.getPTGroupData();
            },
            onOpacityChange(v) {
                this.value.opacity = parseFloat((v / 100).toFixed(2));
                this.onValueChange('opacity');
            },
            onBgValChange(v) {
                this.value.isBgImg = v === '1' ? true : false;
                this.value.isBgMaterialImg = v === '2' ? true : false;
                this.onValueChange('isBgImg');
                this.onValueChange('isBgMaterialImg');
            },
            getParentByChildren(parent, childItem) {
                parent.children.forEach((item) => {
                    if (item === childItem) {
                        this.pData = parent;
                        return;
                    }
                    if (item.children) {
                        return this.getParentByChildren(item, childItem)
                    }
                })
                return this.pData;
            },
            getPTGroupData() {
                let paramsPT = {
                    projectId: this.tplData.projectId,
                    templateIds: [this.tplData.id],
                    type: group_type_pt
                }
                groupService.getGroupList(paramsPT).then(({list}) => {
                    this.pintuList = list;
                });
            },
            onUploadCompleted(dataList) {
                let cloneData = JSON.parse(JSON.stringify(dataList)).concat(this.pintuList);
                this.saveGroup(cloneData).then(() => {
                    let {projectId, id} = this.tplData;
                    this.getPTGroupData(projectId, id);
                });
            },
            saveGroup(groupList) {
                let {id, projectId} = this.tplData;
                let cloneData = JSON.parse(JSON.stringify(groupList));
                return groupService.addGroup(cloneData, projectId, id);
            },
            onDelGroupItem(item, index) {
                let {projectId} = this.tplData;
                groupService.deleteGroups([item.id], projectId).then(() => {
                    this.pintuList.splice(index, 1);
                    this.$message.success('删除成功')
                });
            },
            onCheckChange(checked) {
                this.value.isCircle = checked;
                this.onValueChange('isCircle');
            },
            onRadiusChange(value) {
                this.value.borderRadius = value;
                this.onValueChange('borderRadius');
            },
            onValueChange(key) {
                let value = this.value[key];
                this.dataList.forEach((item) => {
                    item.key = util.getUUID();
                    this.$set(item, key, value);
                });
            },
            formatterOpacityTip(val) {
                return `${val}%`
            },
        }
    }
</script>